/*eslint-disable*/
const defaultCombiningPercents = require('./combiningPercents.json');
const MIN_ARR_LGTH_OF_DIGIT_CAP = 2;

export default {
  methods: {
    generateEquationNumbers() {
      this.numbers = [];
      let digit = this.equationGetCapacityByDifficult();
      if (this.parameters.fractions) {
        digit += +this.parameters.fractionalPart;
      }
      let amountOfActions = +this.parameters.amountOfActions;
      let amountOfUnknowns = +this.parameters.amountOfUnknowns;
      let amountOfNumbers = amountOfActions - amountOfUnknowns;
      let num = null;
      let unknown = this.generateNumberForEquation(digit, this.correctAnswer);
      this.correctAnswer = Math.abs(unknown);
      for (let i = 0; i < amountOfNumbers; i++) {
        num = this.generateNumberForEquation(digit, num, unknown);
        this.numbers.push(num);
      }
      let negativeUnknowns = 0;
      let positiveUnknowns = 0;
      for (let i = 0; i < amountOfUnknowns; i++) {
        if (Math.random() > 0.5 && _.sum(this.numbers) - unknown > 0) {
          this.numbers.push(-unknown);
          negativeUnknowns++;
        } else {
          this.numbers.push(unknown);
          positiveUnknowns++;
        }
      }
      if (positiveUnknowns === negativeUnknowns && positiveUnknowns + negativeUnknowns === amountOfUnknowns) {
        if (Math.random() > 0.5 && _.sum(this.numbers) - unknown * 2 > 0) {
          for (let i = 1; i < this.numbers.length; i++) {
            if (this.numbers[i] === unknown) {
              this.numbers[i] = -unknown;
              break;
            }
          }
        } else {
          for (let i = this.numbers.length; i > 0; i--) {
            if (this.numbers[i] === -unknown) {
              this.numbers[i] = unknown;
              break;
            }
          }
        }
      }
      if (amountOfUnknowns === amountOfActions - 1 && Math.random() > 0.5) {
        for (let i = 0; i < this.numbers.length; i++) {
          if (Math.abs(this.numbers[i]) !== Math.abs(unknown) && _.sum(this.numbers) - this.numbers[i] * 2 > 0) {
            this.numbers[i] = -this.numbers[i];
            break;
          }
        }
      }
      if (this.parameters.negativeAnswers && Math.random() > 0.5) {
        this.correctAnswer = -this.correctAnswer;
      }
      this.equationAnswer = this.parameters.fractions
        ? +_.sum(this.numbers).toFixed(this.parameters.fractionalPart)
        : _.sum(this.numbers);
      this.numbers = _.shuffle(this.numbers);
      for (let i = 1; i < this.numbers.length; i++) {
        if (this.numbers[i] > 0 && !(this.correctAnswer < 0 && Math.abs(this.numbers[i]) === Math.abs(this.correctAnswer))) {
          let swap = this.numbers[0];
          this.numbers[0] = this.numbers[i];
          this.numbers[i] = swap;
          break;
        }
      }
    },
    generateNumberForEquation(digitCapacity, prevNumber, unknown) {
      let generatedNumber;
      let generatedInteger;
      if (this.parameters.combining) {
        let changedCombiningPercents = this.equationChangeCombiningPercents();
        digitCapacity = this.equationGenerateCurrentDigitsLimit(digitCapacity, changedCombiningPercents);
      }
      let allowLessCapacity = this.parameters.fractions && (digitCapacity - +this.parameters.fractionalPart) === 1;
      do {
        generatedNumber = Math.floor(Math.random() * Math.pow(10, digitCapacity));
        generatedNumber = Math.random() > 0.5 ? generatedNumber : -generatedNumber;
        generatedInteger = generatedNumber;
        if (this.parameters.fractions) {
          generatedNumber /= Math.pow(10, +this.parameters.fractionalPart);
        }
      } while (generatedNumber === 0
        || generatedNumber === prevNumber
        || Math.abs(generatedNumber) === unknown
        || _.sum(this.numbers) + generatedNumber <= 0
        || (!allowLessCapacity && Math.abs(generatedInteger).toString().length !== digitCapacity)
      );
      return generatedNumber;
    },
    equationGenerateCurrentDigitsLimit (digitsLimit, combiningPercents) {
      let currentDigitsLimit;
      if (this.parameters.fractions) {
        digitsLimit -= +this.parameters.fractionalPart;
      }
      let randomPercent = Math.floor(Math.random() * 100);
      let remainingPercent = 100;
      for (let i = digitsLimit; i > 0; i--) {
        if (randomPercent >= (remainingPercent -= combiningPercents[digitsLimit][i])) {
          currentDigitsLimit = i;
          if (this.parameters.fractions) {
            currentDigitsLimit += +this.parameters.fractionalPart;
          }
          return currentDigitsLimit;
        }
      }
    },
    equationChangeCombiningPercents() {
      let combiningPercents = _.cloneDeep(defaultCombiningPercents);
      let capacityLimit = this.equationGetCapacityByDifficult();
      if (this.parameters.combiningDigitCapacities.length >= MIN_ARR_LGTH_OF_DIGIT_CAP) {
        let capacitiesWhichNeedToResetChance = _.difference(
          _.map(
            _.keys(combiningPercents[capacityLimit]), (key) => {
              return +key;
            }
          ),
          this.parameters.combiningDigitCapacities
        );
        if (capacitiesWhichNeedToResetChance.length) {
          capacitiesWhichNeedToResetChance.forEach((capacity) => {
            combiningPercents[capacityLimit][capacity] = 0;
          });
          let newChancePercents = _.values(_.cloneDeep(
            defaultCombiningPercents[this.parameters.combiningDigitCapacities.length]
          ));
          this.parameters.combiningDigitCapacities.forEach((capacity, index) => {
            combiningPercents[capacityLimit][capacity] = newChancePercents[index];
          });
        }
      }
      return combiningPercents;
    },
    equationGetCapacityByDifficult() {
      if (this.parameters.difficult === 'Однозначные цифры') {
        return 1;
      } else if (this.parameters.difficult === 'Двузначные цифры') {
        return 2;
      } else if (this.parameters.difficult === 'Трехзначные цифры') {
        return 3;
      } else if (this.parameters.difficult === 'Четырехзначные цифры') {
        return 4;
      } else if (this.parameters.difficult === 'Пятизначные цифры') {
        return 5;
      } else if (this.parameters.difficult === 'Шестизначные цифры') {
        return 6;
      } else if (this.parameters.difficult === 'Семизначные цифры') {
        return 7;
      } else if (this.parameters.difficult === 'Восьмизначные цифры') {
        return 8;
      }
    }
  }
}
